import React from "react";
import AllCategoriesFour from "./CategoryModule/AllCategoriesFour";

const CategoriesFour = () => {
  return (
    <div>
      <AllCategoriesFour />
    </div>
  );
};

export default CategoriesFour;
